import { clearCanvas, setupCanvas } from './canvas-utils';

export function renderCorrelationMatrix(
    canvas: HTMLCanvasElement,
    labels: string[],
    matrix: number[][],
): void {
    const setup = setupCanvas(canvas);
    if (!setup) return;
    const { ctx, width, height } = setup;

    clearCanvas(ctx, width, height);
    if (labels.length === 0 || matrix.length === 0) return;

    const n = Math.min(labels.length, matrix.length);
    const cellW = width / n;
    const cellH = height / n;

    const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));

    for (let row = 0; row < n; row += 1) {
        for (let col = 0; col < n; col += 1) {
            const value = clamp(matrix[row]?.[col] ?? 0, -1, 1);
            const up = value >= 0;
            const alpha = 0.18 + (Math.abs(value) * 0.75);
            ctx.fillStyle = up
                ? `rgba(21,181,122,${alpha})`
                : `rgba(217,71,54,${alpha})`;
            ctx.fillRect(col * cellW, row * cellH, Math.max(1, cellW - 1), Math.max(1, cellH - 1));
        }
    }

    ctx.strokeStyle = 'rgba(255,255,255,0.18)';
    ctx.strokeRect(0.5, 0.5, width - 1, height - 1);
}
